<template>
  <div class="Warning">
    <WarningTop v-show="WarningData.length > 0" ref="WarningTopRef" :TopList="TopList" @TopClick="WaringTopClick" @searchClick="searchClick"></WarningTop>
    <WarningList :WarningData="WarningData" :total="total" :pageSize="pageSize" @handleCurrentChange="WarnhandleCurrentChange" @handleSizeChange="WarnhandleSizeChange"></WarningList>
  </div>
</template>

<script>
import WarningTop from './components/warningTop'
import WarningList from './components/WarningList.vue'
import {
  HelperWarningType,
  HomeRemindGetForWarning
} from '@/api/channel'
export default {
  name: 'earlyWarningCcenter',
  components: {
    WarningTop,
    WarningList
  },
  data() {
    return {
      CusWebMenus: null,
      Menus: null,
      TopList: [

      ],
      WarningData: [

      ],
      total: null,
      pageSize: 12,
      pageindex: null,
      Code: '',
      Type: ''
    }
  },
  created() {

  },
  mounted() {
    this.HomeRemindGetForWarning()
    this.HelperWarningType()
  },
  methods: {
 
    searchClick(value) {
      this.Code = value
      this.HomeRemindGetForWarning()
    },
    // 获取预警菜单
    async HelperWarningType() {
      let {
        code,
        data,
        message
      } = await HelperWarningType({

      })
      if (code == 0) {
        this.TopList = data
      } else {
        this.$message.warning(message)
      }
    },
    // 预警列表
    async HomeRemindGetForWarning() {
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let {
        code,
        message,
        data
      } = await HomeRemindGetForWarning({
        Type: this.Type,
        Code: this.Code,
        pageSize: this.pageSize,
        pageIndex: this.pageindex
      })
      if (code == 0) {
        this.total = data.Count
        this.WarningData = data.data
      } else {
        this.$message.warning(message)
      }
      loading.close();
    },
    // 头部菜单
    WaringTopClick(par) {
      this.Type = par.Value
      this.pageindex = 1
      this.HomeRemindGetForWarning()
    },
    // 分页
    WarnhandleSizeChange(PageSize) {
      this.pageSize = PageSize;
      this.HomeRemindGetForWarning();
    },
    WarnhandleCurrentChange(PageIndex) {
      this.pageindex = PageIndex;
      this.HomeRemindGetForWarning();
    }
  },
  watch: {
    $route: {
      handler(to, from) {
        console.log(to.query.NodeID, from);
    // 获取菜单
        // 获取渠道管理全部菜单
        this.CusWebMenus = JSON.parse(localStorage.getItem("MenusData")).CusWebMenus
        let MenuID = to.query.NodeID;
        // 过滤获取到对应的菜单
        this.CusWebMenus.map((item, index) => {
          if (item.NodeID == MenuID) {
            this.Menus = item
          }
        })
        // 获取菜单列表
        this.MenuList = this.Menus.Nodes
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="less" scoped>
.Warning {
  width: 1200px;
  min-height: 650px;
  // border: 1px solid red;
  margin: 16px auto;
  position: relative;
  top: 16px;
}
</style>